let facials_element = [
  'doc',
  'Name',
  'Price',
  'Skin Type',
  'Item Form',
  'Finish',
  'Active Ingredient',
  'Main Feature',
  'Ratings',
];
let facials = [
  [
    '1',
    'Aloe Serum',
    '27000',
    'Sensitive, Troubled',
    'Oil',
    'Sticky',
    'Hyaluronic Acid, Panthenol, Glucoside, Aloe Vera',
    'Soothing, Nutritive',
    '4.8',
    'https://morestore.co.kr/web/product/big/202105/64275b097bed542fbb14d821f7762cea.jpg',
    '3',
    'https://morestore.co.kr/product/detail.html?product_no=352&cate_no=1&display_group=40',
  ],
  [
    '7',
    'Trouble Cream',
    '25000',
    'Combination, Sensitive, Troubled',
    'Watery',
    'Fresh, Cool',
    'Propanediol, Bottleweed Extract, Panthenol',
    'Trouble Care, Hypoallergenic',
    '4.3',
    'https://morestore.co.kr/web/product/big/20200522/01d8450ea33af3e6cd5505e717dd8738.jpg',
    '3',
    'https://morestore.co.kr/product/detail.html?product_no=104&cate_no=1&display_group=40',
  ],
  [
    '8',
    'Tea Tree Gel',
    '32000',
    'Dry, Sensitive, Troubled',
    'Cream',
    'Soft, Fresh',
    'Butylene Glycol, Capric Triglyceride, Vegetable Oil',
    'Soothing, Nutritive',
    '4.9',
    'https://morestore.co.kr/web/product/big/202105/e96d5edbd6f053ca7529c2c1847f243b.jpg',
    '3',
    'https://morestore.co.kr/product/detail.html?product_no=351&cate_no=1&display_group=40',
  ],
  [
    '9',
    'Mamonde Lotion',
    '8000',
    'Normal, Sensitive',
    'Watery',
    'Soft, Cool',
    'Propanediol, Glycerin, Cyclohexyloxane',
    'Wrinkle Improvement',
    '3.2',
    'https://shopping-phinf.pstatic.net/main_2156149/21561491214.20191219163802.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/21561491214?query=로션&NaPm=ct%3Dkp0krjsg%7Cci%3D2abb221c3aa5c9d9c1cd11eed915bd29473541d6%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3D59ad52b579519a500f4415aadd4588dae5203bfe',
  ],
  [
    '10',
    'Acnes Lotion',
    '8000',
    'Oily, Troubled',
    'Cream',
    'Sticky',
    'Butylene Glycol, Apple Water, Olive Oil, Glycerin',
    'Soothing, Trouble Care',
    '3.7',
    'https://shopping-phinf.pstatic.net/main_1802743/18027436133.20190313114731.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/18027436133?query=로션&NaPm=ct%3Dkp0ktkbk%7Cci%3D44f7935c849dbd79843cbabb873a90bf81159bf9%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3Db1b7bedb8b2317b16d1c8eb5affc146918dab227',
  ],
];

let tissue_element = [
  'Docs',
  'Name',
  'Price',
  'Ply Rating',
  'Main Feature',
  'Material',
  'Sheet Count',
  'Package Type',
  'Rating',
];

let tissue = [
  [
    '3',
    'Napkin Set',
    '11000',
    '3-ply',
    'Natural pulp, No fluorescence, Colorless, Fragrance free',
    'cotton',
    '4',
    'pack',
    '4.1',
    'https://morestore.co.kr/web/product/big/202007/edaab347cb891638e7e57b9b090f1c56.jpg',
    '2',
    'https://morestore.co.kr/product/search.html?banner_action=&keyword=%EB%83%85%ED%82%A8',
  ],
  [
    '15',
    'Cotton Napkin',
    '10000',
    '1-ply',
    'Natural pulp, No fluorescence, Colorless, Fragrance free',
    'cotton',
    '10',
    'reusable',
    '4.6',
    'https://morestore.co.kr/web/product/big/202007/de933cb615035c87e485d6c8c83178c6.jpg',
    '2',
    'https://morestore.co.kr/product/%EC%86%8C%EB%9D%BD-%EC%99%80%EC%9E%85%EC%8A%A4-%EB%A9%B4%EB%83%85%ED%82%A8-%EB%A6%AC%ED%95%84-10%EB%A7%A4%EC%9E%85/118/category/79/display/1/',
  ],
  [
    '16',
    'Makeup Wipes',
    '6000',
    '2-ply',
    'Natural pulp, No fluorescence, Colorless, Fragrance free',
    'cotton',
    '3',
    'pack',
    '4.0',
    'https://morestore.co.kr/web/product/big/202104/5c02a392f988d4076c4a81e2b517747b.jpg',
    '3',
    'https://morestore.co.kr/product/%EC%86%8C%EB%9D%BD-%EB%A9%94%EC%9D%B4%ED%81%AC%EC%97%85-%EC%99%80%EC%9E%85%EC%8A%A4-l-3%EB%A7%A4%EC%9E%85/292/category/79/display/1/',
  ],
  [
    '17',
    'Kleenex Tissue',
    '11000',
    '3-ply',
    'Natural pulp, No fluorescence, Colorless, Fragrance free',
    'cotton',
    '30',
    'roll',
    '4.1',
    'https://shopping-phinf.pstatic.net/main_2105173/21051735457.20191114161731.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/21051735457?query=휴지&NaPm=ct%3Dkp0l1h1k%7Cci%3D89e47aaf1219cddebd008796b0208402644e47e7%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3D21e55e7f8efe78704ad51208714a5ea8be6ad41b',
  ],
  [
    '18',
    'Facial Tissue',
    '1000',
    '2-ply',
    'Natural pulp, No fluorescence, Fragrance free',
    'cotton',
    '840',
    'pack',
    '4.2',
    'https://shopping-phinf.pstatic.net/main_5602940/5602940127.20200602173738.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/5602940127?query=티슈&NaPm=ct%3Dkp0l41mw%7Cci%3D6738757f7af5d00358135ff03a72d43e4d9c76a8%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3Df0c021ea38329fcde5681efdf9cd540bac9bbffc',
  ],
];

let toothpaste_element = [
  'Docs',
  'Name',
  'Price',
  'Main Feature',
  'Capacity',
  'Formulation',
  'Rating',
];

let toothpaste = [
  [
    '4',
    'Solid Toothpaste',
    '11000',
    'Fluorine free,  Colorless, No CPC',
    '50',
    'solid',
    '4.5',
    'https://morestore.co.kr/web/product/big/202010/1e5fc9571b0341a9ccb2e8ec1b40fe2c.jpg',
    '3',
    'https://morestore.co.kr/product/%ED%86%A428-%EB%8D%B4%ED%8B%B0-%ED%81%AC%EB%9F%AC%EC%89%AC-%EA%B3%A0%EC%B2%B4-%EC%B9%98%EC%95%BD/185/category/79/display/1/',
  ],
  [
    '19',
    'Natural F',
    '12800',
    'Colorless',
    '120g',
    'tube',
    '4.7',
    'https://morestore.co.kr/web/product/big/202009/859e0d4b246a2b12c546eedf460fb94d.jpg',
    '2',
    'https://morestore.co.kr/product/%EB%8B%A5%ED%84%B0%EB%85%B8%EC%95%84-%EB%84%A4%EC%B6%94%EB%9F%B4-f-%EC%B9%98%EC%95%BD-%EB%B6%88%EC%86%8C/159/category/79/display/1/',
  ],
  [
    '20',
    'Bergamot Toothpaste',
    '8700',
    'Fluorine free,  Colorless, No CPC',
    '120g',
    'tube',
    '5',
    'https://morestore.co.kr/web/product/big/20200623/8af06ecb6b50c1419bc26c3ac34eec4e.jpg',
    '3',
    'https://morestore.co.kr/product/%EC%8E%84%EB%B9%84%EB%B3%B4%ED%83%80%EB%8B%89-%EB%B2%A0%EB%A5%B4%EA%B0%80%EB%AA%BB-%EC%B9%98%EC%95%BD/52/category/79/display/1/',
  ],
  [
    '21',
    'Median Toothpaste',
    '800',
    'None',
    '120g',
    'tube',
    '4.8',
    'https://shopping-phinf.pstatic.net/main_1708656/17086566557.20190118135839.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/17086566557?query=치약&NaPm=ct%3Dkp0l5qlc%7Cci%3D3b9ad8ca08fbaefa656de5dbca4d7d0aa2d479ab%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3Da5532c2a899c19a981ed06318cbc1ca88449d7cb',
  ],
  [
    '22',
    'Fresh Toothpaste',
    '700',
    'Fluorine free,  No CPC',
    '160g',
    'tube',
    '4.8',
    'https://shopping-phinf.pstatic.net/main_1241350/12413500385.20171009112326.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/12413500385?query=치약&NaPm=ct%3Dkp0l7ky8%7Cci%3Deb6f382f510f76b957c1163987f9fcc40f6a6ef7%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3D227eacf04f1e099fbc88789e4351cacdec6be31e',
  ],
];

let scrubber_element = ['Docs', 'Name', 'Price', 'Material', 'Rating'];
let scrubber = [
  [
    '27',
    'Natural Scrubber',
    '5000',
    'Loofah cucumber',
    '4.9',
    'https://morestore.co.kr/web/product/big/202007/65ddb62d39c323baba4751134a9d1440.jpg',
    '2',
    'https://morestore.co.kr/product/%EB%A3%A8%ED%8C%8C%EB%82%98%EB%AC%B4-%EC%B2%9C%EC%97%B0-%EC%88%98%EC%84%B8%EB%AF%B8-%EC%A3%BC%EB%B0%A9%EC%9A%A9/82/category/80/display/1/',
  ],
  [
    '28',
    'Hemp Scrubber',
    '10000',
    'Burlap',
    '4.5',
    'https://morestore.co.kr/web/product/big/20200416/1df355597fa17a2535218e57d5d515cb.jpg',
    '3',
    'https://morestore.co.kr/product/%EC%98%88%EA%B3%A0%EC%9D%80%EC%82%BC%EB%B2%A0-%EC%B2%9C%EC%97%B0-%EC%82%BC%EB%B2%A0-%EC%88%98%EC%84%B8%EB%AF%B8-3%EA%B0%9C%EC%9E%85/94/category/80/display/1/',
  ],
  [
    '29',
    'String Scrubber',
    '7000',
    'Burlap',
    '3.9',
    'https://morestore.co.kr/web/product/big/202011/712701fd834d88773577efc4dd4e3428.jpg',
    '2',
    'https://morestore.co.kr/product/%EC%98%88%EA%B3%A0%EC%9D%80%EC%82%BC%EB%B2%A0-%EC%B2%9C%EC%97%B0-%EC%82%BC%EB%B2%A0-%EC%88%98%EC%84%B8%EB%AF%B8%EC%8B%A4/199/category/80/display/1/',
  ],
  [
    '30',
    'Disposable Scrubber',
    '15000',
    'plastic',
    '4.7',
    'https://shop-phinf.pstatic.net/20200403_118/1585880238846e1Ojd_JPEG/23240977477159170_1104095918.jpg?type=m510',
    '0',
    'https://smartstore.naver.com/dailywater/products/4590891546?n_media=27758&n_query=%EC%9D%BC%ED%9A%8C%EC%9A%A9%EC%88%98%EC%84%B8%EB%AF%B8&n_rank=2&n_ad_group=grp-a001-02-000000009392694&n_ad=nad-a001-02-000000103689279&n_campaign_type=2&n_mall_pid=4590891546&n_ad_group_type=2&NaPm=ct%3Dkp1jlvnk%7Cci%3D0za0002eDoDukiV3df1l%7Ctr%3Dpla%7Chk%3D8ffdb6132f70dbe3d4017f4c0ebc4b7d87ac048b',
  ],
  [
    '31',
    'Scotch Scrubber',
    '6000',
    'plastic',
    '4.0',
    'https://shopping-phinf.pstatic.net/main_2404690/24046909842.20200905010453.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/24046909842?query=%EC%88%98%EC%84%B8%EB%AF%B8&NaPm=ct%3Dkp1jortk%7Cci%3Db219f539f25208dfadae8ae305ebebdd0155d94a%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3Dcb919be20b95ea19d49b809181745514b5f0934a',
  ],
];

let bag_element = [
  'Docs',
  'Name',
  'Price',
  'Purpose',
  'Material',
  'Capacity',
  'Safety',
  'Waterproof',
  'Strap drop',
  'Pockets',
  'Rating',
];
let bag = [
  [
    '5',
    'Backpack',
    '79000',
    'backpack',
    'recycled fiber',
    'laptops, chargers, and iPads',
    'X',
    'X',
    '55~74',
    'one zipper pocket, two-stage inner storage',
    '4.8',
    'https://morestore.co.kr/web/product/big/202012/4aa655ae4e2847da27869de1dc2aa9a2.jpg',
    '2',
    'https://www.cueclyp.com/product/RDB_BK',
  ],
  [
    '23',
    'Cross Bag',
    '49000',
    'crossbody bag',
    'recycled fiber',
    'smartphones, cards, and cash',
    'X',
    'X',
    '55~109',
    'two zipper-pockets, one slot pocket',
    '4.5',
    'https://morestore.co.kr/web/product/big/202012/4051d61be1893df2790fd1c08db1f4e6.jpg',
    '2',
    'https://www.cueclyp.com/product/RMC_GR',
  ],
  [
    '24',
    'Pocket Bag',
    '32000',
    'pocket bag',
    'recycled fiber',
    'smartphone, muld-card pouch, Airpod case and mask',
    'X',
    'X',
    'cross strap',
    'frot pocket',
    '4.3',
    'https://morestore.co.kr/web/product/big/202012/36b471a16cb07bd9f2c3d883d94ddf29.jpg',
    '2',
    'https://morestore.co.kr/product/%ED%81%90%ED%81%B4%EB%A6%AC%ED%94%84-%EC%8A%A4%EB%A7%88%ED%8A%B8-%ED%8F%AC%EC%BC%93%EB%B0%B1/214/category/81/display/1/',
  ],
  [
    '25',
    'Nike bag',
    '15000',
    'hip pack',
    'polyester',
    'smartphone, muld-card pouch, Airpod case and mask',
    'X',
    'O',
    'cross strap',
    'two pockets, one mesh inner pocket',
    '4.7',
    'https://shopping-phinf.pstatic.net/main_2563565/25635659000.20210315153418.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/25635659000?query=가방&NaPm=ct%3Dkp0l9vig%7Cci%3Dd8a5ef905045928c01627f8eb856ee7b5ab75fcd%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3Dd542233fbca2ad835ee774b0cb9e1a840353ec28',
  ],
  [
    '26',
    'Carhartt Backpack',
    '32000',
    'backpack',
    'polyester',
    'laptops, chargers, and iPads',
    'X',
    'O',
    '48~76',
    'two zipper pocket',
    '4.5',
    'https://shopping-phinf.pstatic.net/main_2554231/25542315208.20210109004546.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/25542315208?query=백팩&NaPm=ct%3Dkp0ldhww%7Cci%3Dad44a68c3ee916e73714e4298266a07dae48827c%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3D95aeffd7dc0cfb5e4d3506490e16a0de17e5f948',
  ],
];

let detergent_element = [
  'docs',
  'Name',
  'Price',
  'Ingredient',
  'Form',
  'Cleaning power',
  'Volume',
  'Rating',
];

let detergent = [
  [
    '32',
    'Washing Bar 150g',
    '6000',
    'coconut oil',
    'solid',
    'middle',
    '150g',
    '4.3',
    'https://morestore.co.kr/web/product/big/202010/f302f9ab260c754249f1dbd42f62e09f.jpg',
    '3',
    'https://morestore.co.kr/product/%EB%8F%99%EA%B5%AC%EB%B0%AD-%EC%98%AC%EB%B0%94%EB%A5%B8-%EC%84%A4%EA%B1%B0%EC%A7%80-%EC%9B%8C%EC%8B%B1%EB%B0%94-150g/49/category/80/display/1/',
  ],
  [
    '33',
    'Washing Bar 500g',
    '14000',
    'coconut oil',
    'solid',
    'high',
    '500g',
    '4.6',
    'https://morestore.co.kr/web/product/big/202009/d480c39f39c33ee118f3d312d1f5ea5b.jpg',
    '3',
    'https://morestore.co.kr/product/%EB%8F%99%EA%B5%AC%EB%B0%AD-%EC%98%AC%EB%B0%94%EB%A5%B8-%EC%84%A4%EA%B1%B0%EC%A7%80-%EC%9B%8C%EC%8B%B1%EB%B0%94-500g/124/category/80/display/1/',
  ],
  [
    '34',
    'Dish Soap',
    '14000',
    'natural ingredients',
    'solid',
    'high',
    '200g',
    '4.8',
    'https://morestore.co.kr/web/product/big/202105/c89c564737e0b7d0ef40510b94be50ca.jpg',
    '3',
    'https://morestore.co.kr/product/%EB%AA%A8%EC%96%B4%ED%8F%AC%EB%AA%A8%EB%A0%88-%EB%94%94%EC%89%AC-%EC%95%A4-%EB%B2%A0%EC%A7%80-%EC%86%9D-200g/337/category/80/display/1/',
  ],
  [
    '35',
    'Travel Detergent',
    '17000',
    'surfactants',
    'sheet',
    'high',
    '120 sheets',
    '4.5',
    'https://shop-phinf.pstatic.net/20190522_227/ljh7776_1558479028891nFBTF_JPEG/41110208388288634_1235680284.jpg?type=m510',
    '0',
    'https://smartstore.naver.com/gogohappy/products/4519064479?NaPm=ct%3Dkp1k3o34%7Cci%3D03f8c3052e1ba8319299955d5887c420691c475e%7Ctr%3Dslsl%7Csn%3D914677%7Chk%3Dad30be85f3dbd280acc160b84072b6824a9d76a5',
  ],
  [
    '36',
    'LG detergent',
    '5000',
    'surfactants',
    'liquid',
    'middle',
    '450mL',
    '4.4',
    'http://img1a.coupangcdn.com/image/vendor_inventory/images/2017/07/15/1/9/3a08392d-4e00-46b4-ac5c-2049504f43f1.jpeg',
    '0',
    'https://www.coupang.com/vp/products/13000?itemId=260052&vendorItemId=3199916157&src=1032001&spec=10305201&addtag=400&ctag=13000&lptag=P13000&itime=20210524041343&pageType=PRODUCT&pageValue=13000&wPcid=35564539111134572267537&wRef=cr.shopping.naver.com&wTime=20210524041343&redirect=landing&isAddedCart=',
  ],
];

let cushion_element = [
  'docs',
  'Name',
  'Price',
  'Cover',
  'Filling',
  'Feature',
  'Dimension',
  'Rating',
];
let cushion = [
  [
    '6',
    'Cushion Bed',
    '47000',
    'polyester, cotton',
    'cotton(linen upcycling)',
    'Change shape',
    '90*100cm',
    '4.0',
    'https://morestore.co.kr/web/product/big/20200109/e3e51ddf19f340c8c38ea3210b61aa0d.jpg',
    '2',
    'https://morestore.co.kr/product/%ED%95%98%EC%9D%B4%EC%82%AC%EC%9D%B4%ED%81%B4-%EB%A9%80%ED%8B%B0%EC%9B%A8%EC%9D%B4-2%EB%8B%A8-%EC%BF%A0%EC%85%98%EB%B2%A0%EB%93%9C/63/category/79/display/1/',
  ],
  [
    '37',
    'Origo Cushion 50X50',
    '70000',
    'Handmade woven fabric',
    'Kapok(natural fiber)',
    'Use cushion for two usage',
    '50*50cm',
    '4.2',
    'http://thumbnail.10x10.co.kr/webimage/image/basic/36/B000360034.jpg?cmd=thumb&w=500&h=500&fit=true&ws=false',
    '3',
    'http://www.10x10.co.kr/shopping/category_prd.asp?itemid=360034',
  ],
  [
    '38',
    'Origo Cushion 30X50',
    '46000',
    'Handmade woven fabric',
    'Kapok(natural fiber',
    'Change shape',
    '30*50cm',
    '4.5',
    'https://contents.lotteon.com/itemimage/LO/10/47/10/44/77/_1/04/71/04/47/8/LO1047104477_1047104478_1.jpg/dims/resizef/554X554',
    '3',
    'https://s.lotteon.com/QUNxuLSUX6',
  ],
  [
    '39',
    'Polyester Cushion Cover',
    '11000',
    'polyester',
    'cotton',
    'Designed cover',
    '50*50cm',
    '4.3',
    'https://contents.lotteon.com/itemimage/LO/10/38/45/78/58/_1/03/84/57/85/9/LO1038457858_1038457859_1.jpg/dims/resizef/554X554',
    '1',
    'https://s.lotteon.com/aJ9bXZmaD',
  ],
  [
    '40',
    'Polyester Inner Cushion',
    '10000',
    'cotton',
    'polyester',
    'Cheap price',
    '40*40cm',
    '3.6',
    'http://item.ssgcdn.com/27/58/51/item/1000049515827_i1_1200.jpg',
    '1',
    'http://shinsegaemall.ssg.com/item/itemView.ssg?itemId=1000049515827&siteNo=6004&salestrNo=6005&tlidSrchWd=',
  ],
];

let shampoo_element = [
  'docsid',
  'Name',
  'Price',
  'Hair type',
  'Volume',
  'Active Ingredient',
  'Main feature',
  'Rating',
];
let shampoo = [
  [
    '2',
    'Scalp Shampoo',
    '20000',
    'all',
    're-fill, 500mL',
    'Rosemary extracts, Pine leaves extracts, BHA',
    'Scaling',
    '4.3',
    'https://morestore.co.kr/web/product/big/202105/2488ae58abc270a3850fa66cfd2558e8.jpg',
    '3',
    'https://morestore.co.kr/product/%EC%95%84%EB%A1%9C%EB%A7%88%ED%8B%B0%EC%B9%B4-%EB%A1%9C%EC%A6%88%EB%A7%88%EB%A6%AC-%EC%8A%A4%EC%B9%BC%ED%94%84-%EC%8A%A4%EC%BC%80%EC%9D%BC%EB%A7%81-%EC%83%B4%ED%91%B8-400ml/346/category/79/display/1/',
  ],
  [
    '11',
    'Protein Shampoo',
    '18000',
    'all',
    're-fill, 500mL',
    'Quinoa extracts, Ceramide, LPP, BHA',
    'Protein clinic',
    '4.1',
    'https://morestore.co.kr/web/product/big/202105/e32ff1d04519ff2c1d1a024aab6c0f5a.jpg',
    '2',
    'https://morestore.co.kr/product/%EC%95%84%EB%A1%9C%EB%A7%88%ED%8B%B0%EC%B9%B4-%ED%80%B4%EB%85%B8%EC%95%84-%ED%94%84%EB%A1%9C%ED%8B%B4-%EC%83%B4%ED%91%B8-400ml/342/category/79/display/1/',
  ],
  [
    '12',
    'Shampoo Bar',
    '13500',
    'all',
    'bar, 120g',
    'Rosemary leaves oil, Coco-betaine, Olive oil',
    'Washing hair',
    '4.7',
    'https://morestore.co.kr/web/product/big/202102/04c79fb733dc30fc05429b84e519ef25.jpg',
    '3',
    'https://morestore.co.kr/product/%EB%AA%A8%EC%96%B4%ED%8F%AC%EB%AA%A8%EB%A0%88-%EB%A6%AC%ED%94%84%EB%A0%88%EC%8B%B1-%EC%83%B4%ED%91%B8-%EB%B0%94/282/category/79/display/1/',
  ],
  [
    '13',
    'Perfect Shampoo',
    '3000',
    'all',
    'liquid, 680mL',
    'SLES, Dimethicone, Perfume, Cetyl alcohol',
    'Hair relief, washing hair',
    '4.7',
    'https://shopping-phinf.pstatic.net/main_1071522/10715228956.20200720152240.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/10715228956?query=샴푸&NaPm=ct%3Dkp0kvuvs%7Cci%3Dc85882618d6d018c2f5004757b002677cba6f06c%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3D52853b75a53b816033181060a736b3ae5d5b3cdc',
  ],
  [
    '14',
    'Perfume Shampoo',
    '3000',
    'all',
    'liquid, 600mL',
    'SLES, Dimethicone, Perfume, Cetyl alcohol',
    'Perfume shamoo',
    '4.4',
    'https://shopping-phinf.pstatic.net/main_6752893/6752893870.20190905142440.jpg?type=f640',
    '0',
    'https://search.shopping.naver.com/catalog/6752893870?query=샴푸&NaPm=ct%3Dkp0kxyi0%7Cci%3Db9adf9882db3c46727bff901b204e9685b30d0ec%7Ctr%3Dslsl%7Csn%3D95694%7Chk%3D7b70a03803cf6d3e46b996751204ff7e1d11bde7',
  ],
];

export { facials_element, facials };
export { tissue_element, tissue };
export { toothpaste_element, toothpaste };
export { scrubber_element, scrubber };
export { bag_element, bag };
export { detergent_element, detergent };
export { cushion_element, cushion };
export { shampoo_element, shampoo };
